import { useContext, createContext, useState } from 'react';

const NavContext = createContext();

export function useNavContext() {
    return useContext(NavContext);
}

function NavProvider({ children }) {  
  const [activeSection, setActiveSection] = useState("");

  return (
      <NavContext.Provider value={{activeSection, setActiveSection}}>
          {children}
      </NavContext.Provider>
  );
}

export default NavProvider;